import { Avatar, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';

export const KAvatarItem = ({
  user = { position: '', name: '', src: '', showPosition: false },
  name,
  src,
  showName,
  avatarProps = {},
  size = 'md-bold',
  color = 'secondary-900',
  containerProps = {},
  lineHeight = 'normal',
}) => {
  let { position, showPosition } = user;
  return (
    <Flex
      gap="4px"
      alignItems="center"
      {...containerProps}
      className={'avatar-item'}
    >
      <Flex flexDirection={'column'}>
        <Avatar name={name} src={src} {...avatarProps} />
      </Flex>
      <Flex flexDirection={'column'}>
        {showName && (
          <TruncatedTextWithTooltip
            color={color}
            size={size}
            text={name}
            maxW="260px"
            enableTooltip={true}
            lineHeight={lineHeight}
          />
        )}
        {(showPosition || position) && (
          <KText color={'secondary-700'} fontSize={'14px'}>
            {position || '-'}
          </KText>
        )}
      </Flex>
    </Flex>
  );
};
